import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class GuageChart extends Component  {
    constructor(props) {
        super(props);

        console.log("percentage 1: ", this.props.ratio);

        this.state = {
            options: {
                chart: {
                    height: 250,
                    type: 'radialBar',
                },
                colors: ['#004C90'],
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                labels: ['Median Ratio'],
            },
            series: [this.props.ratio]
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.chartValue !== this.props.chartValue) {

            console.log("percentage 2: ", this.props.ratio);

            this.setState({
                options: {
                    chart: {
                        height: 250,
                        type: 'radialBar',
                    },
                    colors: ['#004C90'],
                    plotOptions: {
                        radialBar: {
                            startAngle: -135,
                            endAngle: 135,
                            dataLabels: {
                                name: {
                                    fontSize: '16px',
                                    color: undefined,
                                    offsetY: 120
                                },
                                value: {
                                    offsetY: 76,
                                    fontSize: '22px',
                                    color: undefined,
                                    formatter: function (val) {
                                        return val + "%";
                                    }
                                }
                            }
                        }
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            shadeIntensity: 0.15,
                            inverseColors: false,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 50, 65, 91]
                        },
                    },
                    labels: ['Median Ratio'],
                },
                series: [this.props.ratio]
            })
        }
    }

    render() {
        return (
            <div>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="radialBar"
                    height="400px"
                />
            </div>
        );
    }
}

export default GuageChart